import { bounds } from './chunk-QF7HVQZZ.js';

// src/svg.ts
var Svg = {
  split: (str) => {
    const out = [];
    const parts = String(str || "").trim().split(/\s+/);
    for (const part of parts) {
      const segs = part.split(",");
      for (const s of segs) out.push(isNaN(Number(s)) ? s : +s);
    }
    return out;
  },
  shapeLength: (el) => {
    const tag = el?.tagName?.toLowerCase();
    if (!tag) return 0;
    if (tag === "circle") {
      const r2 = parseFloat(el?.getAttribute("r") ?? "0") || 0;
      return 2 * Math.PI * r2;
    }
    if (tag === "line") {
      const x1 = parseFloat(el?.getAttribute("x1") ?? "0") || 0;
      const x2 = parseFloat(el?.getAttribute("x2") ?? "0") || 0;
      const y1 = parseFloat(el?.getAttribute("y1") ?? "0") || 0;
      const y2 = parseFloat(el?.getAttribute("y2") ?? "0") || 0;
      const dx = x2 - x1;
      const dy = y2 - y1;
      return Math.sqrt(dx * dx + dy * dy);
    }
    try {
      const svgEl = el;
      if (typeof svgEl.getTotalLength === "function") {
        return svgEl.getTotalLength();
      }
    } catch {
    }
    const r = bounds(el);
    return 2 * (r.width + r.height);
  }
};

export { Svg };
//# sourceMappingURL=chunk-LPTJKXJO.js.map
//# sourceMappingURL=chunk-LPTJKXJO.js.map